import Source from '../components/Source'
import LicenseFileLocations from './fragments/LicenseFileLocations'
import { Page } from './types'

type CreateFloatingClientLicenseFileProps = {
    os: string,
    isContainer: boolean
}

const render = ({ os, isContainer }: CreateFloatingClientLicenseFileProps) => <>
    <p>When using a Token Server, the Gurobi component that solves your model does not have its
        own license key but instead retrieves a token from the Token Server. It must therefore know
        where to find the Token Server. For this you can create a client license. You need to specify
        at least the <code>TOKENSERVER</code> parameter.
    </p>
    <p>Here is an example of the simplest Token Server client license file.</p>
    <pre>
        TOKENSERVER=hostname
    </pre>
    <LicenseFileLocations os={os} isContainer={isContainer} description='client license file'/>
    <Source href="https://www.gurobi.com/documentation/{version}/quickstart_linux/creating_a_token_server_cl.html"/>
</>

const CreateFloatingClientLicenseFile : Page<CreateFloatingClientLicenseFileProps> = { key: 'create-floating-client-license', title: 'Creating a Token Server client license', render }

export default CreateFloatingClientLicenseFile